import { useMemo } from 'react'
import MaterialType from '../../types/api/material-type'
import type MaterialEntity from '../../types/api/material'
import { StrapiDataItem } from '../../types/strapi/strapi'

export interface GroupedMaterial {
    type: MaterialType
    materials: StrapiDataItem<MaterialEntity>[]
}

export default function useGroupedMaterialsByType(
    materials?: StrapiDataItem<MaterialEntity>[] | null
): GroupedMaterial[] {
    return useMemo(() => {
        if (!materials || materials.length === 0) {
            return []
        }

        const grouped = new Map<string, { type: MaterialType; materials: StrapiDataItem<MaterialEntity>[] }>()

        materials.forEach(item => {
            const typeDocId = item.material_type?.documentId
            if (!typeDocId || !item.material_type) return

            const existing = grouped.get(typeDocId)
            if (existing) {
                existing.materials.push(item)
            } else {
                grouped.set(typeDocId, {
                    type: item.material_type,
                    materials: [item],
                })
            }
        })

        return Array.from(grouped.values()).map(group => ({
            ...group,
            materials: group.materials.sort((a, b) => a.width - b.width),
        }))
    }, [materials])
}

